import React from 'react';
import '../../css/Account.css';
import TituloPagina from '../../js/Components/PageTitle';
import IsLoggedIn from '../../js/Components/IsLoggedIn';

const Account: React.FC = () => {
  return (
    <div>
      <TituloPagina title="DentalPuente | Tu Cuenta" pageSlug="account" />

      <IsLoggedIn cookieName="user">
        {{
          notExist:
            <main className="account-page content-wrap">
              <section className="account-shell">
                <aside className="account-card account-card--info">
                  <div className="account-card__header">
                    <span className="account-card__icon" aria-hidden="true">🦷</span>
                    <div>
                      <p className="dp-eyebrow">Portal de pacientes</p>
                      <h1>Tu cuenta DentalPuente</h1>
                      <p>
                        Accede con tu correo para consultar tu información y dar seguimiento a tus datos dentro del sistema DentalPuente.
                      </p>
                    </div>
                  </div>

                  <div className="account-feature-list" aria-label="Beneficios del portal">
                    <span>Acceso seguro</span>
                    <span>Consulta rápida</span>
                    <span>Datos protegidos</span>
                  </div>
                </aside>

                <form
                  className="account-card account-card--login account-form"
                  action="/switch.php?ac=login"
                  method="post"
                >
                  <div className="account-card__header">
                    <span className="account-card__icon" aria-hidden="true">🔐</span>
                    <div>
                      <p className="dp-eyebrow">Iniciar sesión</p>
                      <h2>Bienvenido</h2>
                      <p>Ingresa tus datos de acceso.</p>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="emailInput">Tu dirección de email</label>
                    <input
                      type="email"
                      className="form-control"
                      id="emailInput"
                      aria-describedby="emailHelp"
                      placeholder="tu-correo@email.com"
                      name="emailInput"
                      autoComplete="email"
                      required
                    />
                    <small id="emailHelp" className="form-text text-muted">
                      Utilizamos tu cuenta de correo como identificador único.
                    </small>
                  </div>

                  <div className="form-group">
                    <label htmlFor="passwordInput">Tu contraseña de acceso</label>
                    <input
                      type="password"
                      className="form-control"
                      id="passwordInput"
                      placeholder="Contraseña"
                      name="passwordInput"
                      autoComplete="current-password"
                      required
                    />
                  </div>

                  <button type="submit" className="account-submit">
                    Conectar
                  </button>
                </form>
              </section>
            </main>,
          exist:
            <main className="account-page content-wrap">
              <section className="account-shell account-shell--logged">
                <article className="account-card account-card--info">
                  <div className="account-card__header">
                    <span className="account-card__icon" aria-hidden="true">✅</span>
                    <div>
                      <p className="dp-eyebrow">Sesión activa</p>
                      <h1>Ya estás conectado</h1>
                      <p>Tu sesión de DentalPuente está activa. Puedes entrar al panel administrativo real.</p>
                    </div>
                  </div>

                  <a href="/Panel" className="account-submit account-submit--link">
                    Ir al panel
                  </a>
                </article>
              </section>
            </main>
        }}
      </IsLoggedIn>
    </div>
  );
};

export default Account;
